const PLACE_ID_KEYS = [
  "_id",
  "id",
  "placeId",
  "placeUniqueNumber",
  "publicId",
  "contentid",
  "contentId",
];

const toFiniteNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : null;
};

export const getPlaceId = (place, index = 0) => {
  const id = PLACE_ID_KEYS.map((key) => place?.[key]).find(
    (value) => value != null && value !== ""
  );

  return id ?? `place-${index}`;
};

export const getPlaceLatLng = (place) => {
  const coordinates = place?.geometry?.coordinates;
  const coordinateLng = Array.isArray(coordinates)
    ? toFiniteNumber(coordinates[0])
    : null;
  const coordinateLat = Array.isArray(coordinates)
    ? toFiniteNumber(coordinates[1])
    : null;
  const lat = coordinateLat ?? toFiniteNumber(place?.latitude ?? place?.lat);
  const lng = coordinateLng ?? toFiniteNumber(place?.longitude ?? place?.lng);

  if (lat == null || lng == null) return null;

  return { lat, lng };
};
